import { Link } from 'react-router-dom';
import './ArchiveDrawer.css';

/**
 * The "Archive Pieces" drawer beneath the closet wall — a long pull-out drawer
 * standing on four legs (its own piece of furniture). The whole body is French
 * oak (matching the closet door frames), with a metallic silver nameplate
 * centred on the front and two knobs flanking it. Click opens /archive (the
 * searchable history of every post).
 */
export function ArchiveDrawer() {
  return (
    <Link to="/archive" className="archive-drawer" aria-label="Open the archive">
      <span className="archive-drawer__plate">Archive Pieces</span>
      <span className="leg leg--bl" aria-hidden="true" />
      <span className="leg leg--br" aria-hidden="true" />
      <span className="knob round dknob a" aria-hidden="true" />
      <span className="knob round dknob b" aria-hidden="true" />
      <span className="leg leg--fl" aria-hidden="true" />
      <span className="leg leg--fr" aria-hidden="true" />
    </Link>
  );
}
